var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickupPointIcon = function SvgPickupPointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#F4F4F4",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.156 21.559C17.899 20.023 21 16.886 21 14.007a6 6 0 0 0-1.757-4.248 5.997 5.997 0 0 0-8.486 0A6 6 0 0 0 9 14.007c0 2.879 3.1 6.016 4.844 7.552a1.735 1.735 0 0 0 2.312 0M13 14.007a2.003 2.003 0 0 1 2-2.003 2 2 0 0 1 2 2.003 2.003 2.003 0 0 1-2 2.002 2 2 0 0 1-2-2.002"
  })));
};
export default SvgPickupPointIcon;